module.exports = __webpack_public_path__ + "static/about-us-game.e37f73c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-us-game.jpg
// module id = 252
// module chunks = 35783957827783 114276838955818